import axios from 'axios'

import { ROUTES } from 'settings/settings'
import { LogService } from 'services/Log/Log'
import { IUserSnowflake } from 'models/models'

export async function saveUserInSnowflake(user: IUserSnowflake) {
  try {
    const { data } = await axios({
      method: 'POST',
      url: `/${ROUTES.user}`,
      data: user,
    })

    return { data }
  } catch (error: any) {
    LogService.error({ message: 'getUsers', error })
    return { data: null, error: error.response?.data?.errorMessage }
  }
}
